import React, { FC, useCallback, useEffect, useState } from "react";
import EChartsReact from "echarts-for-react";
import { trafficLight } from "../../theme";
import {
    IDamsList, IStateOfKnowledge
} from "../../types/types";
import {
    Accordion,
    AccordionSummary, Chip, ClickAwayListener,
    Divider, Grow, IconButton, MenuItem, Drawer,
    Paper, Popper, Toolbar, Grid, Dialog, DialogActions,
    DialogContent, Collapse,
    DialogTitle, Checkbox, FormGroup, FormControlLabel, Tooltip, List, ListItem, ListItemText, ListItemIcon, ListItemSecondaryAction,
} from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';


const useStyles = makeStyles((theme) => ({
    nested: {
        paddingLeft: theme.spacing(4),
        fontSize: '1rem',
    },
    nestedHeadings: {
        fontWeight: 600,
    }
}));





interface IFMChartProps {
    damList: IDamsList[],
    stateOfKnowledge: IStateOfKnowledge[]
    returnFunction?: any
}


const Filter: FC<IFMChartProps> = ({ damList, stateOfKnowledge, returnFunction }) => {

    const classes = useStyles();

    const [loaded, setLoaded] = useState(false);

    const [valleyList, setValleyList] = useState<Array<string>>([]);
    const [valleyDams, setValleyDams] = useState<any>([]);

    const [checkBoxStates, setCheckBoxStates] = useState<{ [index: string]: boolean }>({});
    const [checkBoxAll, setCheckBoxAll] = useState<boolean>(true);
    const [checkBoxValley, setCheckBoxValley] = useState<{ [index: string]: boolean }>({});
    const [valleyNest, setValleyNest] = useState<{ [index: string]: boolean }>({});



    /////////////////////////// USE Effects ///////////////////////////////

    // this effect sets the valleyNest componant
    useEffect(() => {
        const vally_list_collapsed: { [index: string]: boolean } = {}

        damList.map(d => {
            // add the valleys to the list of valley check box states
            const valley_name = d.dam.valley;

            // add the valley to the nested list of valleys and set it to closed (false)
            if (!(valley_name in vally_list_collapsed)) {
                vally_list_collapsed[valley_name] = false
            }
        })

        setValleyNest(vally_list_collapsed)

    }, [])

    // this effect sets the valleyList componant
    useEffect(() => {

        // get the valley names from the dam list
        const valley_names: { [index: string]: any } = {}
        const valley_name_list: Array<string> = []
        const vally_checked_list = checkBoxValley

        const vally_list_collapsed = valleyNest

        damList.map(d => {
            // add the valleys to the list of valley check box states
            let valley_name = d.dam.valley;

            if (valley_name) {
                valley_name = valley_name
            } else {
                valley_name = "No Valley"
            }

            // if valley_name not in valley_names, add it
            if (!valley_names[valley_name]) {
                valley_names[valley_name] = []

            }

            // add it to the valley_name_list too if not in the list already
            if (!valley_name_list.includes(valley_name)) {
                valley_name_list.push(valley_name)
            }

            if (!vally_checked_list[valley_name]) {
                vally_checked_list[valley_name] = true

            }

            // add the dam to the list of dams for this valley if not in list
            if (!valley_names[valley_name].includes(d.dam.name)) {
                valley_names[valley_name].push(d.dam.name)
            }
        })

        setValleyList(valley_name_list)
        setValleyDams(valley_names)
        setCheckBoxValley(vally_checked_list)

    }, [])

    // initially set all the dam checkboxes to true
    useEffect(() => {

        let list = checkBoxStates
        for (let d in damList) {
            list = { ...list, [`${damList[d].dam.name}`]: true }
        }


        setCheckBoxStates(list)
        setLoaded(true)
    },[])

    // use effect to link the checkboxes to the state of knowledge
    useEffect(() => {
        // get the selected dams from the dam list
        const selected_dams = damList.filter(d => checkBoxStates[`${d.dam.name}`])

        // get the assessment_project_id from the selected dams
        const assessment_project_ids = selected_dams.map(d => d.id)


        // filter the state of knowledge for the given assessment project ids
        const filtered_state_of_knowledge: Array<IStateOfKnowledge> = []

        // for each of the assessment project ids
        const elements = assessment_project_ids.map(id => {
            // filter the state of knowledge for the given assessment project id
            const filtered = stateOfKnowledge.filter(s => s.assessment_project_id === id)
            // push the filtered state of knowledge to the filtered state of knowledge array
            filtered.forEach(element => filtered_state_of_knowledge.push(element))

        })

        returnFunction(assessment_project_ids, selected_dams)

    }, [checkBoxStates])


    /////////////////////////// CHECKBOX HANDLERS ////////////////////////////////

    // when a tick box is checked or unchecked, this needs to be added or removed from the stake of
    // knowledge to be displayed.

    const handleCheckboxChange = (e: any) => {

        if (e.target.checked) {
            setCheckBoxStates({ ...checkBoxStates, [`${e.target.id}`]: true })

        } else {
            setCheckBoxStates({ ...checkBoxStates, [`${e.target.id}`]: false })
        }
    }

    const handleCheckboxChangeAll = (e: any) => {

        let list = checkBoxStates
        let valley_list = checkBoxValley
        // turn all the checkboxes on or all
        if (checkBoxAll) {

            for (let d in damList) {
                list = { ...list, [`${damList[d].dam.name}`]: false }
            }

            for (let d in valleyList) {
                valley_list = { ...valley_list, [`${valleyList[d]}`]: false }

            }
        }

        else {
            for (let d in damList) {
                list = { ...list, [`${damList[d].dam.name}`]: true }
            }
            for (let d in valleyList) {
                valley_list = { ...valley_list, [`${valleyList[d]}`]: true }

            }
        }

        setCheckBoxStates(list)
        setCheckBoxValley(valley_list)
        setCheckBoxAll(!checkBoxAll)

    }

    const handleCheckboxChangeValley = (e: any) => {

        //get the list of dams in the valley
        let dams = valleyDams[e.target.id]
        

        let list = checkBoxStates



        if (checkBoxValley[e.target.id]) {

            // turn all the dams in the valley off
            for (let d in dams) {
                
                list = ({ ...list, [`${dams[d]}`]: false })
            }

        } else {

            // turn all the dams in the valley on
            for (let d in dams) {
                
                list = ({ ...list, [`${dams[d]}`]: true })
            }


        }

        // change the state of the checkbox
        setCheckBoxValley({ ...checkBoxValley, [e.target.id]: !checkBoxValley[e.target.id] })
        setCheckBoxStates(list)


    }

    const handleCollapse = (name: string) => {

        const vally = name
        

        if (valleyNest[vally]) {
            setValleyNest({ ...valleyNest, [vally]: false })
        }
        else {
            setValleyNest({ ...valleyNest, [vally]: true })
        }


    }


    /////////////////////////////// Main Render Function ////////////////////////////////

    const generate_nav_list = () => {

        // iterate through and get all the unique valleys
        const valley_list = Array.from(new Set(damList.map(d => d.dam.valley)))

        // iterate through the vallues and create an array of dams
        const nav_list = valley_list.map(v => {
            let valley_name: string = ""

            if (v) {
                valley_name = v
            }
            else {
                valley_name = 'No Valley'
            }

            const dams_in_valley = Array.from(new Set(damList.filter(d => d.dam.valley === v).map(
                d => d.dam.name)))

            return {
                name: valley_name,
                dams: dams_in_valley
            }

        })

        // now create the structre for the checkbox list

        return (

            <>
                <h2>Valley</h2>
                <Divider />
                <List>
                    <ListItem key='all' button dense>
                        <ListItemIcon>
                            <Checkbox onChange={handleCheckboxChangeAll} checked={checkBoxAll} />
                        </ListItemIcon>
                        <ListItemText primary='All Dams' classes={{ primary: classes.nestedHeadings }} />
                    </ListItem>
                    {nav_list.map(v => {
                        const valley_name = v.name

                        return (
                            <div>
                                <Divider />
                                <ListItem key={v.name} button dense >
                                    <ListItemIcon>
                                        <Checkbox id={v.name} checked={checkBoxValley[v.name]} onChange={handleCheckboxChangeValley} />
                                    </ListItemIcon>
                                    <ListItemText primary={v.name} classes={{ primary: classes.nestedHeadings }} />
                                    <ListItemSecondaryAction>
                                        <IconButton edge="end" onClick={(e) => {
                                            e.preventDefault()
                                            handleCollapse(v.name)
                                        }}>


                                            <KeyboardArrowDownIcon id={v.name} />
                                        </IconButton>
                                    </ListItemSecondaryAction>
                                </ListItem>
                                <Divider />
                                <Collapse in={valleyNest[v.name]} timeout="auto" >


                                    {v.dams.map(d => {

                                        return (
                                            <ListItem key={d} id={d} button dense onClick={handleCheckboxChange} className={classes.nested}>
                                                <ListItemIcon>
                                                    <Checkbox id={d} checked={checkBoxStates[d]} onChange={handleCheckboxChange} />
                                                </ListItemIcon>
                                                <ListItemText primary={d} />
                                            </ListItem>)
                                    })}
                                </Collapse>
                            </div>)
                    })}
                </List>
            </>
        )

    }


    if (!loaded) {
        return <h1>Loading</h1>
    }

    return (
        <>
            {generate_nav_list()}
        </>
        
    )
    

}


export default Filter;